/*
Account deletion
This container signed-out-popup is a Shopify embedded container that isn't hosted on the store.
That's why we cannot modify it easily.
To do so about the content like adding new structure, we need to use js
*/

function initAccountDeletionDesignCustomization() {
  const ShopifySignedOutPopupContainer = document.querySelector(".signed-out-popup");

  if (ShopifySignedOutPopupContainer) {
    let currentText = ShopifySignedOutPopupContainer.innerHTML;

    /* Add carriage return after "..." in text */
    currentText = currentText.replace('...','...<br>');

    ShopifySignedOutPopupContainer.innerHTML = 
      '<div class="signed-out-popup-inner">' +
        '<div class="signed-out-popup-inner-message-container">' +
          '<div class="signed-out-popup-inner-message-container-icon"></div>' +
          '<div class="signed-out-popup-inner-message-container-text">' +
            currentText +
          '</div>' +
        '</div>' +
      '</div>';
  }
}

document.addEventListener("DOMContentLoaded", () => {
  initAccountDeletionDesignCustomization();
})